// src/hooks/useToken.js
import { useContext } from 'react'
import { UserContext } from 'src/contexts/UserContext'

export default function useToken() {
  const context = useContext(UserContext)
  if (!context) {
    throw Error('useToken should be used in UserProvider')
  }
  return context
}
